// autogenerated
import {AthenaeumConstants, ServiceProvider, GeoCoordinate} from "@reapptor-apps/reapptor-toolkit";

export default class StartTripRequest {

    public bookingId: string = "";

    public location: GeoCoordinate | null = null;

    public readonly isStartTripRequest: true = true;

    public static is(from?: object | null): boolean {
        // noinspection PointlessBooleanExpressionJS
        return (from != null) && ((from instanceof StartTripRequest) || ((from as any).isStartTripRequest === true));
    }

    public static as(from?: object | null): StartTripRequest | null {
        return (StartTripRequest.is(from)) ? from as StartTripRequest : null;
    }

    // #region Placeholder

    // Put your code here (function, properties, ect...)

    // #endregion
}

ServiceProvider.addType(StartTripRequest, "StartTripRequest");